import type { Unset } from "../../dom/async/hooks";

export const on = <K extends keyof MediaQueryListEventMap>(
  q: MediaQueryList,
  type: K,
  listener: (this: MediaQueryList, ev: MediaQueryListEventMap[K]) => unknown,
): Unset => {
  if (typeof q.addEventListener === "function") {
    q.addEventListener(type, listener);
    return () => q.removeEventListener(type, listener);
  }

  /*                  */
  /*                                                                                 */
  /*                                                                                          */
  q.addListener(listener);
  return () => q.removeListener(listener);
};

/**
 *
 *
 *
 *
 *
 *
 */
export const digestMessage = async (
  message: string,
  algo: AlgorithmIdentifier = "SHA-1",
): Promise<string> => {
  /*                                             */
  const hashBuffer = await crypto.subtle.digest(algo, new TextEncoder().encode(message));

  /*                                                        */
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};
